import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'recrewt-primary-bg-layout',
  templateUrl: './primary-bg-layout.component.html',
  styleUrls: ['./primary-bg-layout.component.scss'],
  imports: [FlexModule, MatIconButton, MatIcon, RouterOutlet, FooterComponent],
})
export class PrimaryBgLayoutComponent {
  location = inject(Location);
}
